// extracted by mini-css-extract-plugin
export default {"spinner":"userverified_spinner__9s1-0","loader":"userverified_loader__ZjJS6","error":"userverified_error__TdiiQ"};